export default __webpack_public_path__ + "static/media/international.95ac4b1c.png";